import styled from '@emotion/styled';
import {colors} from 'ui/config';
import {Img, TextSmall} from 'ui';

export const Slide = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: 98,
  marginRight: 7,
  marginLeft: 7,
});

export const Image = styled(Img)({
  width: 98,
  height: 57,
});

export const ProductName = styled(TextSmall)({
  fontSize: 13,
  color: colors.darkBrown,
  textAlign: 'center',
  marginBottom: 6,
});
